var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { instanceToPlain, plainToInstance } from 'class-transformer';
import queries from 'constants/queries';
import { Account, PaginationMetaData } from 'models';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import ApiService from '../ApiService';
import { useNavigate } from 'react-router';
var AccountService = /** @class */ (function (_super) {
    __extends(AccountService, _super);
    function AccountService() {
        var _this = _super.call(this) || this;
        _this.accountsRoot = 'accounts';
        _this.successMessage = '';
        return _this;
    }
    AccountService.prototype.useAccounts = function (pageNumber, filters) {
        var _this = this;
        if (pageNumber === void 0) { pageNumber = 1; }
        if (filters === void 0) { filters = {}; }
        return useQuery([queries.accounting.accounts, pageNumber, filters], function () {
            return _this.get(_this.accountsRoot, __assign(__assign({}, filters), { page: pageNumber }));
        }, {
            keepPreviousData: true,
            select: function (_a) {
                var data = _a.data;
                var accounts = plainToInstance(Account, data === null || data === void 0 ? void 0 : data.accounts);
                var meta = plainToInstance(PaginationMetaData, data === null || data === void 0 ? void 0 : data.meta);
                return { accounts: accounts, meta: meta };
            }
        });
    };
    AccountService.prototype.useCreateAccount = function () {
        var _this = this;
        var queryClient = useQueryClient();
        var navigate = useNavigate();
        return useMutation(function (_a) {
            var account = _a.account, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            var data = { account: instanceToPlain(account) };
            return _this.post(_this.accountsRoot, { data: data });
        }, {
            retry: false,
            onSuccess: function () {
                queryClient.invalidateQueries(queries.accounting.accounts);
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
                navigate('/accounts');
            }
        });
    };
    AccountService.prototype.useMiniAccounts = function () {
        var _this = this;
        return useQuery(['mini', queries.accounting.accounts], function () {
            return _this.get("".concat(_this.accountsRoot, "/meta_info"));
        }, {
            select: function (_a) {
                var data = _a.data;
                return plainToInstance(Account, data);
            }
        });
    };
    AccountService.getInstance = function () {
        if (!AccountService.accountService) {
            AccountService.accountService = new AccountService();
        }
        return AccountService.accountService;
    };
    return AccountService;
}(ApiService));
export default AccountService;
